module.exports = __webpack_public_path__ + "static/media/rocket-success.496340f8.svg";